import React, { useState } from "react";

export default function EditOptions({
  type: initialType,
  updateType,
  close,
}) {
  const [type, setType] = useState(initialType);

  // All menu options
  const options = [
    { id: 1, label: "EDIT" },
    // { id: 2, label: "SETTLEMENT" },
    { id: 3, label: "LEDGER" },
    { id: 4, label: "TRADE" },
    { id: 5, label: "STANDING" },
    { id: 6, label: "LOGIN LOG" },
    { id: 7, label: "USER LIST" },
    { id: 8, label: "USER REPORT" },
  ];

  const handleSelect = (id) => {
    setType(id);
    updateType(id);
  };

  return (
    <div className="flex items-center  justify-between px-4 h-[40px] ">
      {/* LEFT SIDE OPTIONS */}
      <div className="flex flex-wrap gap-3">
        {options.map((opt) => (
          <button
            key={opt.id}
            onClick={() => handleSelect(opt.id)}
            className={`NavLinkBtn large
              ${type === opt.id ? "selectlink" : "unselectlink"}
            `}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* RIGHT SIDE CLOSE BUTTON */}
      <button
        onClick={close}
        className={"NavLinkBtn large textwhite mr-3 sell"}
      >
        Close
      </button>
    </div>
  );
}
